// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"5ed065da","299":"580b3794","485":"8fd02428","610":"ca7949ca","631":"b88aa6d2","637":"f8da3269","759":"9b7f85ef","886":"20b0e4be"}[chunkId] + ".chunk.js";
};